import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import ISpecialEventDto from '@core/mappers/specials/dtos/ISpecialEventDto';
import IIncompleteSpecialEventDto from '@core/mappers/specials/dtos/IIncompleteSpecialEventDto';
import SpecialEvent, {
    ISpecialEventIncomplete,
    SpecialEventIncomplete,
    ISpecialEvent,
} from '@core/models/specials/SpecialEvent';
import SpecialMarketMapper from '@core/mappers/specials/SpecialMarketMapper';
import { OfferStatus } from '@core/models/offer/enums';
import SpecialMarket from '@core/models/specials/SpecialMarket';

const specialMarketMapper: SpecialMarketMapper = new SpecialMarketMapper();

type Input = ISpecialEventDto | IIncompleteSpecialEventDto;
type Output = SpecialEvent | SpecialEventIncomplete;

export default class SpecialEventMapper extends AbstractMapper<Input, Output> {
    createTargetObject = (dto: Input) => {
        let event: ISpecialEvent | ISpecialEventIncomplete = {
            fullName: this.extractLocalizedString(dto.name),
            masterName: dto.masterName ? this.extractLocalizedString(dto.masterName) : '',
            id: 0, // just to satisfy typescript
            markets: [],
            date: this.toDate(dto.utcDate),
            order: dto.orderNum,
        };

        // check if it's a full event
        if (this.isFullSpecialEvent(dto)) {
            const specialMarkets = specialMarketMapper.map(dto.betGroups, true) as SpecialMarket[];

            event = ({
                ...event,
                header: this.extractLocalizedString(dto.header, dto.masterHeader),
                footer: this.extractLocalizedString(dto.footer),
                tournamentId: dto.tournamentId ? dto.tournamentId : undefined,
                status: dto.status as OfferStatus,
                sportId: dto.sportId,
                date: this.toDate(dto.utcDate),
                id: dto.offerId,
                markets: specialMarkets,
            }) as ISpecialEvent;
            return new SpecialEvent(event as ISpecialEvent);
        }
        event = new SpecialEventIncomplete({
            ...event,
            markets: specialMarketMapper.map(dto.betGroups, true),
            id: parseInt((<IIncompleteSpecialEventDto>dto).offerId, 10),
        });
        return event as SpecialEventIncomplete;
    }

    /*
        A full special event has more properties than a special event when they're fetched in bulk.
        One of these properties is the 'header' property. It can't be just checked with if(dto.header)
        because it can be an empty string so hasOwnProperty must be used
    */
    private isFullSpecialEvent(dto: Input): dto is ISpecialEventDto {
        // arbitrarily picked property
        if ((<ISpecialEventDto>dto).hasOwnProperty('header')) {
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/specials/SpecialEventMapper.ts